var _g, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(166, 57, 35)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 23.75",
    style: {
      enableBackground: "new 0 0 31 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.813,6C28.363,6,28,6.363,28,6.812V11H3V0.812C3,0.363,2.636,0,2.188,0H0.812C0.364,0,0,0.363,0,0.812v17.375    C0,18.637,0.364,19,0.812,19h1.376C2.636,19,3,18.637,3,18.188V16h25v2.188C28,18.637,28.363,19,28.813,19h1.375    C30.637,19,31,18.637,31,18.188V6.812C31,6.363,30.637,6,30.188,6H28.813z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.928,
    cy: 5.997,
    r: 2.937
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.172,3.043c-0.809-0.084-1.616,0.18-2.22,0.725C11.348,4.312,11,5.088,11,5.901V9h16.146    C25.98,6.685,21.362,3.785,14.172,3.043z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 34,
    fill: "rgb(166, 57, 35)",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Baboon designs")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 39,
    fill: "rgb(166, 57, 35)",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLit);
export default __webpack_public_path__ + "static/media/lit.45de929f3c01a4741ff9a1935bcf1c5c.svg";
export { ForwardRef as ReactComponent };